/*
 *   Copyright (c) 2021 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
  pure:false
})
export class OrderByPipe implements PipeTransform {

  transform(value: any, propertyName: string[]): any {
    if(value && value.length){
      if (propertyName[2] && propertyName[2].length && propertyName[2]==='list') {
        return value.sort((a: any, b: any) => (a[propertyName[0]] ? a[propertyName[0]][propertyName[1]] : a[propertyName[1]]).localeCompare((b[propertyName[0]] ? b[propertyName[0]][propertyName[1]] : b[propertyName[1]])));
      } else  if (propertyName[2] && propertyName[2].length) {
        return value.sort((a: any, b: any) =>{
         return  typeof(a[propertyName[0]][propertyName[1]][propertyName[2]]) === 'number' ?   Number(a[propertyName[0]][propertyName[1]][propertyName[2]]) - Number(b[propertyName[0]][propertyName[1]][propertyName[2]]) : a[propertyName[0]][propertyName[1][propertyName[2]]].localeCompare(b[propertyName[0]][propertyName[1]][propertyName[2]]);
        });
      }  else {
        if (propertyName[0] && value && typeof (value[0][propertyName[0]]) !== 'object') {
          return value.sort((a: any, b: any) => typeof(a[propertyName[0]]) === 'number' ? (a[propertyName[0]] - b[propertyName[0]]): a[propertyName[0]].localeCompare(b[propertyName[0]]));
        } else if (propertyName[0] && value && typeof (value[0][propertyName[0]]) === 'object') {
          return value.sort((a: any, b: any) =>typeof(a[propertyName[0]][propertyName[1]]) === 'number' ?  a[propertyName[0]][propertyName[1]] - (b[propertyName[0]][propertyName[1]]) : a[propertyName[0]][propertyName[1]]? a[propertyName[0]][propertyName[1]].localeCompare(b[propertyName[0]][propertyName[1]]) : 1);
        }
      }
    }else{
      return value;
    }
    
  }
}
